// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__TAQAn","listItem":"EditMenu_listItem__ycpZn","link":"EditMenu_link__tohMT"};